module.exports = __webpack_public_path__ + "img/result-hit-coupon.3344b838.svg";